// extracted by mini-css-extract-plugin
module.exports = {"wrapperInGrid":"Hidden_wrapperInGrid__zWf_A","margin_top":"Hidden_margin_top__exImK","margin_bottom":"Hidden_margin_bottom__NmOXy"};